import AssertionModel from '@/dex-shared/models/AssertionModel';
import ContentModel from '@/dex-shared/models/ContentModel';

export default {
  assertionById: (state: any, getters: any) => (assertionId: number) => {
    let assertion = state.assertions[assertionId];
    if (assertion) {
      return new AssertionModel(assertion, getters);
    } else {
      return {};
    }
  },
  assertionsByQuestionId: (state: any, getters: any) => (
    questionId: number,
  ) => {
    return Object.values(state.assertions)
      .map((assertion: any) => new AssertionModel(assertion, getters))
      .filter(
        (assertion: AssertionModel) => assertion.questionId === questionId,
      );
  },
  contentsByAssertionId: (state: any, getters: any) => (
    assertionId: number,
  ) => {
    return Object.values(state.contents)
      .map((content: any) => new ContentModel(content, getters))
      .filter((content: ContentModel) => content.assertionId === assertionId);
  },
};
